module.exports = __webpack_public_path__ + "static/img/yx3.c410ebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx3.jpg
// module id = D+mU
// module chunks = 1